<template>
  <div>
    <AppNavbar
      :options="options"
      title=""
      :placeholder="true"
      :zIndex="10"
      v-if="isApp"
    >
      <div slot="right">
        <div class="share" @click="bindShare"
          ><span class="iconfont icon-share1"></span
        ></div>
      </div>
    </AppNavbar>
    <div class="cer-container" v-if="endCampData" ref="poster">
      <div class="top">
        <div class="text1">结营证书-{{ endCampData.headerDatum.day }}天</div>
      </div>
      <div class="center-item camp-cer">
        <div class="cer-day">{{ endCampData.headerDatum.day }}天</div>
        <div class="cer-time">{{
          endCampData.headerDatum.time | timeLineToDot
        }}</div>
        <div class="user-info"
          >{{ endCampData.headerDatum.alias }}
          {{ endCampData.user.truename }}</div
        >
        <div class="change-content">
          <div class="change-item"
            ><span class="text">体重</span
            ><span class="num">{{
              endCampData.infoDatum.weight | filterNumber
            }}</span
            ><span class="unit">KG</span></div
          >
          <div class="change-item"
            ><span class="text">腰围</span
            ><span class="num">{{
              endCampData.infoDatum.waist | filterNumber
            }}</span
            ><span class="unit">CM</span></div
          >
          <div
            class="change-item"
            v-if="endCampData.thighDatum && endCampData.thighDatum.first_thigh"
            ><span class="text">大腿围</span
            ><span class="num">{{
              endCampData.infoDatum.thigh | filterNumber
            }}</span
            ><span class="unit">CM</span></div
          >
        </div>
        <div class="diet-container">
          <div class="diet-item"
            ><span class="num">{{ endCampData.infoDatum.meal_day }}</span
            ><span class="text">/{{ endCampData.headerDatum.day }}天</span></div
          >
          <div class="diet-item"
            ><span class="num">{{ endCampData.infoDatum.meal_num }}</span
            ><span class="text"
              >/{{ endCampData.headerDatum.day * 3 }}餐</span
            ></div
          >
          <div class="diet-item"
            ><span class="num">{{ endCampData.infoDatum.star5_num }}</span
            ><span class="text">餐满分</span></div
          >
        </div>
      </div>
      <div class="center">
        <!-- 蜕变历程 -->
        <div v-show="!creatingPoster">
          <div class="title-content">
            <div class="line"></div>
            <div class="title-text">蜕变历程</div>
            <div class="line"></div>
          </div>
          <div class="center-item change-data">
            <div class="data-container radius-content">
              <div class="data-title">身体数据</div>
              <div class="change-item" v-if="endCampData.lineDatum">
                <div>
                  <span class="change-title">体重变化</span
                  ><span class="change-unit">单位：KG</span>
                </div>
                <div class="data-info">
                  <div class="data-left">
                    <span class="left-num">{{
                      (endCampData.lineDatum.current_weight -
                        endCampData.lineDatum.first_weight)
                        | fixed2
                    }}</span
                    ><span class="left-unit">kg</span>
                  </div>
                  <div class="data-right">
                    <div class="right-item start-item">
                      <div class="text">初始体重</div>
                      <div class="num">{{
                        endCampData.lineDatum.first_weight || 0
                      }}</div>
                    </div>
                    <div class="right-item">
                      <div class="text">当前体重</div>
                      <div class="num">{{
                        endCampData.lineDatum.current_weight || 0
                      }}</div>
                    </div>
                  </div>
                </div>
                <div class="echart-container">
                  <!-- echarts -->
                  <LineComponent
                    :xList="endCampData.lineDatum.time"
                    :yList="endCampData.lineDatum.data[0].data"
                  />
                </div>
              </div>
              <!--  -->
              <div class="change-item" v-if="endCampData.waistDatum">
                <div>
                  <span class="change-title">腰围变化</span
                  ><span class="change-unit">单位：CM</span>
                </div>
                <div class="data-info">
                  <div class="data-left">
                    <span class="left-num">{{
                      (endCampData.waistDatum.current_waist -
                        endCampData.waistDatum.first_waist)
                        | fixed2
                    }}</span
                    ><span class="left-unit">cm</span>
                  </div>
                  <div class="data-right">
                    <div class="right-item start-item">
                      <div class="text">初始腰围</div>
                      <div class="num">{{
                        endCampData.waistDatum.first_waist
                      }}</div>
                    </div>
                    <div class="right-item">
                      <div class="text">当前腰围</div>
                      <div class="num">{{
                        endCampData.waistDatum.current_waist
                      }}</div>
                    </div>
                  </div>
                </div>
                <div class="echart-container">
                  <!-- echart -->
                  <LineComponent
                    :xList="endCampData.waistDatum.time"
                    :yList="endCampData.waistDatum.data[0].data"
                  />
                </div>
              </div>
              <!--  -->
              <div
                class="change-item"
                v-if="
                  endCampData.thighDatum && endCampData.thighDatum.first_thigh
                "
              >
                <div>
                  <span class="change-title">大腿围变化</span
                  ><span class="change-unit">单位：CM</span>
                </div>
                <div class="data-info">
                  <div class="data-left">
                    <span class="left-num">{{
                      (endCampData.thighDatum.current_thigh -
                        endCampData.thighDatum.first_thigh)
                        | fixed2
                    }}</span
                    ><span class="left-unit">cm</span>
                  </div>
                  <div class="data-right">
                    <div class="right-item start-item">
                      <div class="text">初始大腿围</div>
                      <div class="num">{{
                        endCampData.thighDatum.first_thigh
                      }}</div>
                    </div>
                    <div class="right-item">
                      <div class="text">当前大腿围</div>
                      <div class="num">{{
                        endCampData.thighDatum.current_thigh
                      }}</div>
                    </div>
                  </div>
                </div>
                <div class="echart-container">
                  <!-- echart -->
                  <LineComponent
                    :xList="endCampData.thighDatum.time"
                    :yList="endCampData.thighDatum.data[0].data"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="center-item" v-show="!creatingPoster">
          <div class="radius-content diet-data">
            <div class="diet-title-content">
              <div class="diet-title">饮食数据</div>
            </div>
            <div class="title1-content">
              <span class="change-title">饮食打卡</span
              ><span class="change-unit"
                >总计：{{ endCampData.dietDatum.totalCount }}/{{
                  endCampData.dietDatum.curCount
                }}</span
              >
            </div>
            <!-- 圆环图 -->
            <div class="diet-type-list">
              <!-- 早餐 -->
              <div class="diet-type-item">
                <div class="circle-content">
                  <!--  <VCircle :data="endCampData.dietDatum.morning + '%'" color="rgb(116,216,200)"></VCircle> -->
                  <van-circle
                    v-model="endCampData.dietDatum.curMorning"
                    :rate="endCampData.dietDatum.morning"
                    size="75"
                    stroke-width="90"
                    color="#D9A8FA"
                    layer-color="#f0f0f0"
                    :speed="100"
                    :text="endCampData.dietDatum.morning + '%'"
                  />
                </div>
                <div class="diet-text">
                  <div class="d-text">早餐卡</div>
                  <div class="d-num"
                    >{{ endCampData.dietDatum.morning_rate }}次</div
                  >
                </div>
              </div>
              <!-- 中午 -->
              <div class="diet-type-item">
                <div class="circle-content">
                  <!-- <VCircle :data="endCampData.dietDatum.afternoon + '%'" color="rgb(255,185,112)"></VCircle> -->
                  <van-circle
                    v-model="endCampData.dietDatum.curAfternoon"
                    :rate="endCampData.dietDatum.afternoon"
                    size="75"
                    stroke-width="90"
                    color="#B4B2FF"
                    layer-color="#f0f0f0"
                    :speed="100"
                    :text="endCampData.dietDatum.afternoon + '%'"
                  />
                </div>
                <div class="diet-text">
                  <div class="d-text">午餐卡</div>
                  <div class="d-num"
                    >{{ endCampData.dietDatum.afternoon_rate }}次</div
                  >
                </div>
              </div>
              <!-- 晚餐 -->
              <div class="diet-type-item">
                <div class="circle-content">
                  <!-- <VCircle :data="endCampData.dietDatum.night + '%'" color="rgb(131,138,174)"></VCircle> -->
                  <van-circle
                    v-model="endCampData.dietDatum.curNight"
                    :rate="endCampData.dietDatum.night"
                    size="75"
                    stroke-width="90"
                    color="#FFB2D7"
                    layer-color="#f0f0f0"
                    :speed="100"
                    :text="endCampData.dietDatum.night + '%'"
                  />
                </div>
                <div class="diet-text">
                  <div class="d-text">晚餐卡</div>
                  <div class="d-num"
                    >{{ endCampData.dietDatum.night_rate }}次</div
                  >
                </div>
              </div>
            </div>
            <div class="title1-text">饮食占比</div>
            <div class="diet-prop-list">
              <div
                class="diet-prop-item"
                v-for="(item, index) in dietProp"
                :key="index"
              >
                <div class="prop-item-left">{{ item.name }}</div>
                <div class="slider-content">
                  <div
                    class="slider-percent"
                    :style="{ width: item.per + '%' }"
                  >
                    <div class="slider-flag">{{ item.desc }}</div>
                  </div>
                </div>
                <!--  <div class="prop-item-right">{{ item.desc }}</div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 餐卡蜕变 -->
        <div v-show="!creatingPoster">
          <div class="title-content">
            <div class="line"></div>
            <div class="title-text">餐卡蜕变</div>
            <div class="line"></div>
          </div>
          <div class="center-item">
            <div class="radius-content score-container">
              <div class="diet-type-content">
                <div class="score-top">80分及以上</div>
                <div class="score-bottom">
                  <div class="score-info">
                    <div class="diet-number excellent-diet">
                      <span class="diet-num">{{
                        endCampData.dietDatum.star5_info.num
                      }}</span
                      ><span class="diet-unit">张</span>
                    </div>
                    <img
                      class="quotation-marks"
                      src="https://cdnvue.gymcity.com.cn/uploads/1542ff745f57710a148a8b9999861429.png"
                    />
                    <div class="desc">
                      <div>每一张优秀的餐卡</div>
                      <div>都是你学习正确饮食的成果</div>
                    </div>
                  </div>
                  <div class="diet-image-list">
                    <img
                      class="diet-image-item"
                      v-for="(item, index) in endCampData.dietDatum.star5_info
                        .img"
                      :key="index"
                      :src="item"
                      @click="
                        previewImage(
                          endCampData.dietDatum.star5_info.img,
                          index
                        )
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="diet-type-content">
                <div class="score-top">80分以下</div>
                <div class="score-bottom">
                  <div class="score-info bad-score-info">
                    <div class="diet-number bad-diet">
                      <span class="diet-num bad-diet-num">{{
                        endCampData.dietDatum.star3_info.num
                      }}</span
                      ><span class="diet-unit">张</span>
                    </div>
                    <img
                      class="quotation-marks"
                      src="https://cdnvue.gymcity.com.cn/uploads/1542ff745f57710a148a8b9999861429.png"
                    />
                    <div class="desc">
                      <div>努力的你</div>
                      <div>正在认真打好每一次餐卡</div>
                    </div>
                  </div>
                  <div class="diet-image-list">
                    <img
                      class="diet-image-item"
                      v-for="(item, index) in endCampData.dietDatum.star3_info
                        .img"
                      :key="index"
                      :src="item"
                      @click="
                        previewImage(
                          endCampData.dietDatum.star3_info.img,
                          index
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 营养师结语 -->
        <div class="title-content">
          <div class="line"></div>
          <div class="title-text">营养师结语</div>
          <div class="line"></div>
        </div>
        <div class="center-item">
          <div class="radius-content coach-comments" v-if="!cid">
            <div class="comment-content">
              <div class="coach-info">
                <img
                  class="coach-avatar"
                  :src="endCampData.coach.c_img || ''"
                />
                <span class="coach-name">{{ endCampData.coach.c_name }}</span>
                <img
                  class="dot-image"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b976b78713f3e1b4a58d9a3780f31116.png"
                />
              </div>
              <div class="coach-say">{{ inputText }}</div>
            </div>
          </div>
          <div
            class="radius-content coach-comments coach-comments-input"
            v-if="cid"
          >
            <div class="coach-input-content">
              <textarea
                v-model="inputText"
                class="coach-input"
                :maxlength="maxLength"
                placeholder="对你的学员说点什么吧"
              />
              <div class="limit-text"
                >{{ inputText.length }}/{{ maxLength }}</div
              >
            </div>
          </div>
        </div>
        <div class="btn-box">
          <div v-if="cid">
            <div class="share-btn" v-if="flag != 2" @click="saveSummary(2)"
              >发布</div
            >
            <div class="share-btn save-btn" @click="saveSummary(1)"
              >保存为草稿</div
            >
          </div>
          <div v-else>
            <div class="end-content"><span class="end-text">END</span></div>
            <div class="share-btn" v-if="isApp" @click="bindShare"
              >生成分享海报</div
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
      position="center"
    >
      <div class="swiper-content">
        <van-swipe
          class="my-swipe"
          :autoplay="1000000"
          indicator-color="white"
          v-if="posterUrlList.length"
          @change="bindSwiperChange"
        >
          <van-swipe-item
            class="swipe-item"
            v-for="(item, index) in posterUrlList"
            :key="index"
            ><img class="swipe-image" :src="item" alt=""
          /></van-swipe-item>
        </van-swipe>
      </div>
    </ShareComponent>
    <div v-for="(item, index) in posterData" :key="index">
      <component
        :is="item.componentName"
        v-if="endCampData"
        :data="endCampData"
      ></component>
    </div>
    <!--    <PosterComponent1 v-if="endCampData" :data="endCampData"></PosterComponent1>
    <PosterComponent2 v-if="endCampData" :data="endCampData"></PosterComponent2> -->
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import VCircle from './components/circle/index'
import VStar from './components/star/index'
import ShareComponent from '@/components/app/share/share.vue'
import {
  eventObj,
  shareImageIcons
} from '@/components/app/share/share-method.js'
import PosterComponent1 from './components/poster-1.vue'
import PosterComponent2 from './components/poster-2.vue'
import LineComponent from './components/line.vue'
export default {
  components: {
    VCircle,
    VStar,
    AppNavbar,
    ShareComponent,
    PosterComponent1,
    PosterComponent2,
    LineComponent
  },
  filters: {
    filterNumber(num) {
      return num > 0 ? '+' + num : num
    },
    fixed2(val) {
      return parseFloat(val.toFixed(2))
    },
    timeLineToDot(val) {
      val = val.replace(/--/g, '#')
      val = val.replace(/-/g, '.')
      val = val.replace(/#/g, ' - ')
      return val
    }
  },
  data() {
    return {
      isApp: false,
      uid: '', //用户id
      cid: '', //教练id
      pid: '', //营期id
      rid: '', //
      summary_id: '',
      flag: 0,
      curTime: new Date().getTime(),
      updateTime: '', //更新时间
      allPosterData: [
        {
          id: 'poster-2',
          componentName: 'PosterComponent2'
        },
        {
          id: 'poster-1',
          componentName: 'PosterComponent1'
        }
      ],
      posterData: [],
      posterUrl: '', //生成的海报
      posterUrlList: [],
      swiperActive: 0,
      iconList: [],
      dietProp: [],
      showPoster: false,
      showShare: false,
      qrcodeUrl: '',
      shareOptions: {
        //分享参数
        url: 'https://member3.gymcity.com.cn/#/app-download',
        desc: '',
        title: '减脂营结营证书',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png'
      },
      creatingPoster: false, //是否正在生成海报
      maxLength: 500,
      inputText: '',
      submiting: false, // 正在提交中
      ecLine: {
        /* canvas图表数据 */ lazyLoad: true
      },
      endCampData: null,
      flagList: ['删除', '保存', '发布'],
      dietArr: [
        {
          name: '早餐',
          number: 24,
          percent: '15%',
          color: 'rgb(116,216,200)'
        },
        {
          name: '午餐',
          number: 24,
          percent: '51%',
          color: 'rgb(255,185,112)'
        },
        {
          name: '晚餐',
          number: 24,
          percent: '34%',
          color: 'rgb(131,138,174)'
        }
      ],
      options: {
        barBackgroundColor: '#fff',
        color: 'rgba(0,0,0,0.8)'
      }
    }
  },
  created() {
    this.getParams()
    this.getQrcodeUrl()
    if (this.cid) {
      if (!this.rid) {
        this.initSummary()
      } else {
        this.getSummary()
      }
    } else {
      this.getMemberSummary()
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getQrcodeUrl() {
      this.qrcodeUrl =
        location.origin + location.pathname + '?rid=' + this.$route.query.rid
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset

      if (scrollTop >= 100) {
        this.title = '今天吃什么'
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, 1)',
          color: 'rgba(0,0,0,0.8)'
        }
      } else {
        this.title = ''
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(0,0,0,0.8)'
        }
      }
    },
    getParams() {
      this.isApp = this.$betterwe.isApp()
      this.cid = +this.$route.query.cid || ''
      this.uid = +this.$route.query.uid || ''
      this.pid = +this.$route.query.pid || ''
      this.rid = +this.$route.query.rid || ''
    },
    //会员获取结营证书
    getMemberSummary() {
      let url = this.$betterwe.isApp()
        ? 'member/AppCamp/getSummary'
        : 'member/AppCamp/getSummaryByVx'
      let params = {
        rid: this.rid
      }
      this.$http
        .getApp(url, params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.endCampData = res.data.content
            this.summary_id = res.data.summary_id
            this.inputText = res.data.summary_text
            this.dietProp = this.dealDietProp(res.data.content.dietDatum)
            this.setPosterData(this.endCampData.is_show_two_poster)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    setPosterData(flag) {
      this.posterData = flag ? this.allPosterData : this.allPosterData.slice(1)
    },
    //营养师初始化结营证书详情
    initSummary() {
      let params = {
        uid: this.uid,
        pid: this.pid,
        cid: this.cid
      }
      this.$http
        .postApp('member/AppCampCoach/initSummary', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.endCampData = res.data
            this.inputText = res.data.summary_text
            this.summary_id = res.data.summary_id
            this.dietProp = this.dealDietProp(res.data.dietDatum)
            this.setPosterData(this.endCampData.is_show_two_poster)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    //有rid则获取结营证书详情
    getSummary() {
      let params = {
        rid: this.rid
      }
      this.$http
        .getApp('member/AppCampCoach/getSummary', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.endCampData = res.data.content
            this.dietProp = this.dealDietProp(res.data.content.dietDatum)
            this.inputText = res.data.summary_text
            this.summary_id = res.data.summary_id
            this.updateTime = this.formatTime(res.data.updatetime || '')
            this.flag = res.data.flag
            this.setPosterData(this.endCampData.is_show_two_poster)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    //处理饮食比例
    dealDietProp(data) {
      data.totalCount = 27
      data.curCount = 33
      let arr = []
      let dietObj = {
        main: '主食',
        protein: '蛋白质',
        veg: '蔬菜'
      }
      let perObj = {
        less: 10,
        mid: 50,
        more: 90
      }
      let descObj = {
        less: '偏少',
        mid: '适中',
        more: '偏多'
      }
      for (let i in data) {
        if (dietObj[i]) {
          let obj = {}
          obj.name = dietObj[i]
          obj.per = perObj[data[i]]
          obj.desc = descObj[data[i]]
          arr.push(obj)
        }
      }
      return arr
    },
    //预览图片
    previewImage(imageList, index) {
      ImagePreview({
        images: imageList,
        startPosition: index,
        loop: false
      })
    },
    formatTime(time) {
      time = time.slice(0, 11).replace(/-/g, '.')
      return time
    },
    //保存或者发布删除结营证书
    saveSummary(flag) {
      if (!this.inputText) {
        this.$toast('内容不能为空')
        return
      }
      if (this.submiting) {
        this.$toast(
          '正在' + this.flagList[flag] + '中,请不要重复' + this.flagList[flag]
        )
        return
      }
      this.submiting = true
      let params = {
        rid: this.rid,
        uid: this.uid,
        pid: this.pid,
        cid: this.cid,
        content: this.inputText,
        flag: flag,
        sid: this.summary_id
      }
      this.$http
        .postApp('member/AppCampCoach/saveSummary', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast(this.flagList[flag] + '成功')
            if (this.flagList[flag] == '保存') {
              this.rid = parseInt(res.data)
            }
            if (this.$betterwe.isApp()) {
              setTimeout(() => {
                this.$betterwe.onAppCloseRoute()
              }, 300)
            }
          } else {
            this.$toast(res.msg)
          }
          this.submiting = false
        })
        .catch(() => {
          this.$toast('异常错误')
          this.submiting = false
        })
    },
    bindShare() {
      this.posterUrlList = []
      this.showShare = true
    },
    bindCancel() {
      this.iconList = []
    },
    bindSwiperChange(index) {
      this.posterUrl = this.posterUrlList[index]
    },
    async bindSelect(options) {
      this.iconList = []
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        case 1:
          let promiseArr = this.posterData.map((item) => {
            return eventObj.createPoster(item.id, true)
          })
          let urls = await Promise.all(promiseArr).catch((e) => {
            this.$toast('生成失败')
          })
          if (!urls) {
            return
          }
          this.iconList = shareImageIcons
          this.posterUrlList = urls
          this.posterUrl = this.posterUrlList[0]
          this.showShare = true
          break
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        case 3:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        case 4:
          break
        case 5:
          eventObj.saveImageToPhone(this.posterUrl)
          break
        case 6:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxFriend(shareOptions)
          break
        case 7:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxCircle(shareOptions)
          break
      }
    }
  }
}
</script>
<style scoped lang="scss">
.cer-container {
  ::v-deep .van-circle__text {
    font-size: 18px;
    font-family: DIN-Bold, DIN;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }

  .top {
    padding: 17px 22px 12px;

    .text1 {
      font-size: 24px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
      line-height: 33px;
      margin-bottom: -8px;
    }
  }

  .center {
    padding: 0px 10px;
  }

  .camp-cer {
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/87254a0d51885b3f05a82cba310204f6.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    height: 489px;

    .cer-day {
      position: absolute;
      left: 288px;
      top: 130px;
      height: 15px;
      line-height: 15px;
      padding: 0 4px;
      background: #383149;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
      border-radius: 5px 5px 5px 0px;
      font-size: 12px;
      font-family: Source-KeynoteartHans-Regular, Source-KeynoteartHans;
      font-weight: 400;
      color: #fffbf6;
      line-height: 14px;
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    }

    .cer-time {
      text-align: center;
      width: 200px;
      position: absolute;
      top: 180px;
      left: 50%;
      transform: translate(-50%, 0%);
      font-size: 15px;
      font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
      line-height: 21px;
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    }

    .user-info {
      white-space: nowrap;
      position: absolute;
      left: 50%;
      top: 225px;
      transform: translate(-50%, 0%);
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
      border-bottom: 1px solid rgba(50, 50, 73, 0.5);
    }

    .change-content {
      width: 100%;
      padding: 0px 25px;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 325px;
      transform: translate(-50%, 0%);
      display: flex;
      justify-content: space-between;

      .change-item {
        flex: 1;
        text-align: center;

        .text {
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 14px;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        }

        .num {
          font-size: 22px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 27px;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        }

        .unit {
          font-size: 10px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 12px;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        }
      }
    }

    .diet-container {
      width: 100%;
      padding: 0px 25px;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 381px;
      transform: translate(-50%, 0%);
      display: flex;
      height: 61px;
      align-items: center;
      justify-content: space-around;

      .diet-item {
        .num {
          font-size: 22px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 27px;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        }

        .text {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 18px;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        }
      }
    }
  }
}

img {
  object-fit: 'contain';
}

.cer-container {
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e527b0545301064e18b57173bd509130.png'),
    linear-gradient(180deg, #ebc192 0%, #f3d6b7 100%);
  min-height: 100vh;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  overflow-x: hidden;
  overflow-y: scroll;
}

.cer-text {
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 3.46vw;
  line-height: 5.86vw;
  letter-spacing: 1px;
  color: #9d4c20;
}

.seal-image {
  position: absolute;
  width: 28.26vw;
  right: -9.6vw;
  bottom: -4.26vw;
}

.achievement-bg {
  width: 100%;
  height: 82.93vw;
}

.achievement-container {
  position: relative;
  margin-top: -13.33vw;
  z-index: 1;
}

.achievement-content {
  position: absolute;
  left: 0;
  top: 28%;
  width: 100%;
  bottom: 3%;
  overflow-y: scroll;
  padding: 0vw 6.66vw;
  box-sizing: border-box;
}

.achievement-content .title {
  text-align: center;
  font-weight: 600;
  line-height: 7.46vw;
  font-family: PingFangSC-Medium;
  font-size: 5.33vw;
  color: #000;
  margin-bottom: 2.93vw;
}

.achievement-content .change-item {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}

.achievement-content .line {
  width: 0.53vw;
  height: 10.13vw;
  background-color: #f1f1f1;
  margin: 0vw 1vw;
}

.achievement-content .change-num {
  font-family: DIN-Medium;
  font-size: 9.06vw;
  font-weight: 600;
  margin-left: 2.13vw;
  margin-right: 0.53vw;
}

.achievement-content .change-unit {
  font-family: DIN-Medium;
  font-size: 3.2vw;
}

.achievement-content .up {
  color: #f04646;
}

.achievement-content .down {
  color: #2882e9;
}

.achievement-content .change-percent {
  font-weight: 600;
  margin-left: 3.73vw;
}

.achievement-content .diet-title {
  text-align: center;
  background-color: #fff;
  width: 18.13vw;
  height: 4.53vw;
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  color: #000;
}

.achievement-content .diet-content {
  display: flex;
  align-items: center;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  color: #000;
  justify-content: space-around;
}

.diet-content .diet-num {
  font-family: DIN-Medium;
  font-size: 5.33vw;
  color: #000;
  font-weight: 600;
}

.title-content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  margin-top: 18px;
}

.title-content .line {
  background-color: rgba(0, 0, 0, 0.5);
  width: 82px;
  height: 1px;
}

.title-content .title-text {
  font-size: 20px;
  font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  line-height: 27px;
  margin: 0px 16px;
}

.radius-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}

.radius-content .data-title {
  margin-bottom: 20px;
  text-indent: 11px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  line-height: 28px;
  position: relative;
}

.data-info {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  .data-left {
    position: relative;
    flex: 1;
    text-align: center;

    .left-num {
      font-size: 44px;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 54px;
    }

    .left-unit {
      margin-left: 4px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
    }
  }

  .data-left::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
    width: 1px;
    height: 37px;
    background-color: #e1e1e1;
  }

  .data-right {
    flex: 1;
    font-family: PingFangSC-Regular;
    font-size: 3.2vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.data-right {
  .right-item {
    text-align: center;
    margin-right: 26px;

    .text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 6px;
    }

    .num {
      font-size: 18px;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
    }
  }

  .right-item:last-child {
    margin-right: 0;
  }
}

.radius-content .data-title::after {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0%, -50%);
  width: 5px;
  height: 17px;
  background: #866bb8;
}

.title1-text {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  line-height: 22px;
  margin-bottom: 25px;
}

.change-data {
  padding-bottom: 8vw;
}

.change-data .right .start-item {
  margin-bottom: 1.33vw;
}

.change-data .right-num {
  font-size: 3.73vw;
  color: #000;
  margin-right: 0.53vw;
  font-weight: 600;
  line-height: 4.53vw;
}

.change-data .echart-container {
  padding: 5.33vw;
  box-sizing: border-box;
  width: 100%;
  height: 66.66vw;
}

.change-data .echart-content {
  width: 100%;
  height: 100%;
}

.radius-content {
  .change-title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    margin-right: 10px;
  }

  .change-unit {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
  }
}

.diet-data {
  .diet-title-content {
    text-align: center;
    margin-bottom: 23px;

    .diet-title {
      position: relative;
      display: inline-block;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 28px;
    }

    .diet-title::before {
      content: '';
      position: absolute;
      width: 44px;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.26);
      right: calc(100% + 16px);
      top: 50%;
    }

    .diet-title::after {
      content: '';
      position: absolute;
      width: 44px;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.26);
      left: calc(100% + 16px);
      top: 50%;
    }
  }

  .diet-type-list {
    display: flex;
    align-items: center;
    margin-top: 22px;
    margin-bottom: 26px;
  }

  .diet-type-item {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    text-align: center;
  }

  .diet-text {
    .d-text {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
      margin-bottom: 2px;
    }

    .d-num {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #313131;
      line-height: 17px;
    }
  }
}

.diet-type-item .circle-content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.diet-prop-list {
  .diet-prop-item {
    display: flex;
    align-items: center;
    margin-bottom: 28px;

    .prop-item-left {
      margin-right: 10px;
      width: 50px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
    }

    .slider-content {
      width: 228px;
      height: 9px;
      background: #e5e5e5;
      border-radius: 5px;

      .slider-percent {
        width: 114px;
        height: 9px;
        background: #866bb8;
        border-radius: 5px 0px 0px 5px;
        position: relative;

        .slider-flag {
          position: absolute;
          padding: 0px 7px;
          line-height: 17px;
          background-color: rgb(51, 51, 51);
          height: 17px;
          border-radius: 10px;
          right: 0px;
          bottom: 16px;
          transform: translate(50%, 0%);
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #ffffff;
        }

        .slider-flag::after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          left: 50%;
          bottom: -4px;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 5px solid rgb(51, 51, 51);
          transform: translate(-50%, 0%);
        }
      }
    }
  }
}

.slider-content .slider-grey::after {
  background-image: radial-gradient(
    circle 0.93vw at 100% 0,
    transparent 0.93vw,
    #fff 50%
  );
}

.score-container {
  padding: 20px 20px 0px;
}

.score-bottom .score-info {
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}

.score-bottom .bad-score-info {
  margin-bottom: 15px;
}

.score-bottom .diet-image-list {
  display: flex;
  align-items: center;
  width: 100%;
  overflow-y: scroll;
}

.score-bottom .diet-image-list::-webkit-scrollbar {
  display: none;
}

.score-bottom .diet-image-item {
  object-fit: cover;
  flex-shrink: 0;
  overflow: hidden;
  width: 54px;
  height: 54px;
  background-color: #f1f1f1;
  border-radius: 1.06vw;
  margin-right: 9px;
}

.score-bottom .quotation-marks {
  width: 3.73vw;
  height: 2.13vw;
  margin-left: 3px;
  margin-right: 11px;
}

.score-bottom .diet-number {
  width: 100px;
  white-space: nowrap;
}

.score-bottom .diet-num {
  font-size: 44px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  line-height: 54px;
  margin-right: 5px;
}

.score-bottom .diet-unit {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  line-height: 17px;
}

.score-bottom .excellent-diet {
  color: rgba(0, 0, 0, 0.8);
}

.score-bottom .bad-diet-num {
  font-size: 9.06vw;
  line-height: 10.93vw;
}

.score-bottom .bad-diet {
  color: rgba(0, 0, 0, 0.3);
}

.score-bottom .desc {
  text-align: left;
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  font-size: 14px;
  font-family: AppleSystemUIFont;
  line-height: 17px;
  letter-spacing: 1px;
  color: rgba(0, 0, 0, 0.7);
}

.score-container .score-title {
  line-height: 5.6vw;
  font-weight: 600;
  font-family: PingFangSC-Medium;
  font-size: 4vw;
  color: #000;
}

.diet-type-content {
  padding-bottom: 36px;

  .score-top {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    margin-bottom: 13px;
  }
}

.coach-comments {
  padding: 20px;
  margin-bottom: 16px;
}

.coach-comments-input {
  margin-bottom: 24px;
}

.coach-input-content {
  width: 100%;
  height: 53.33vw;
  position: relative;
}

.coach-comments .coach-input {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 6.66vw;
  background-color: #fff;
  border-radius: 1.6vw;
  border: solid 1px #f1f1f1;
  border: none;
  line-height: 6.4vw;
  font-size: 3.73vw;
}

.coach-comments .limit-text {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-top: 1.33vw;
  text-align: right;
  line-height: 5.33vw;
  font-family: PingFangSC-Regular;
  font-size: 3.73vw;
  color: rgba(56, 61, 72, 0.5);
}

.comment-content {
  .dot-image {
    width: 42px;
    height: 32px;
    object-fit: cover;
    margin-right: 8px;
  }

  .coach-say {
    text-align: left;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.7);
    line-height: 24px;
    word-break: break-all;
    word-wrap: break-word;
  }

  .coach-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 11px;
  }

  .coach-avatar {
    width: 26px;
    height: 26px;
    border-radius: 9px;
    margin-right: 9px;
  }

  .coach-name {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }
}

.btn-box {
  margin-bottom: 40px;
}

.share-btn {
  box-sizing: border-box;
  height: 40px;
  border-radius: 12px;
  text-align: center;
  line-height: 9.6vw;
  background: #5c4378;
  margin-bottom: 16px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
}

.save-btn {
  color: #5c4378;
  border: 2px solid #5c4378;
  background: transparent;
}

.poster-container {
  z-index: 999;
  overflow-y: scroll;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .poster-image {
    width: 100%;
    height: auto;
  }
}

.bottom {
  background-color: #fdf7e5;
  display: flex;
  align-items: center;
  padding: 9.3vw 5.6vw;
  box-sizing: border-box;
  justify-content: space-between;

  .logo {
    height: 4.8vw;
  }

  .bottom-line {
    text-align: left;
    line-height: 5.6vw;
    font-family: PingFangSC-Regular;
    font-size: 4vw;
    letter-spacing: 0.3vw;
    color: #000;
    border-bottom: solid 0.3vw rgb(126, 125, 120);
    padding-bottom: 1.6vw;
    margin-bottom: 2.4vw;
  }

  .qrcode-image {
    width: 24.5vw;
    height: 24.5vw;
  }
}

.share {
  .iconfont {
    font-size: 24px;
    font-size: 600;
  }
}

.end-content {
  text-align: center;
  margin-bottom: 12px;

  .end-text {
    position: relative;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9d4c20;
    line-height: 17px;
  }

  .end-text::before {
    content: '';
    position: absolute;
    width: 18px;
    height: 1px;
    top: 50%;
    background-color: rgba(157, 76, 32, 0.3);
    right: calc(100% + 10px);
  }

  .end-text::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 1px;
    top: 50%;
    background-color: rgba(157, 76, 32, 0.3);
    left: calc(100% + 10px);
  }
}

.swiper-content {
  height: 100%;
  padding: 30px 0px 10px;

  .my-swipe {
    .swipe-item {
      box-sizing: border-box;
      padding: 0px 16px;
    }

    .swipe-image {
      width: 100%;
    }

    ::v-deep .van-swipe__indicators {
      bottom: -30px;
    }
  }

  ::v-deep .van-swipe {
    overflow: visible;
  }
}
</style>
